import { TAppState, TLangSlug, TOpenGlobalModalPayload } from '../../types/app';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const appTypes = {
  OPEN_GLOBAL_MODAL: 'APP/OPEN_GLOBAL_MODAL',
  CLOSE_GLOBAL_MODAL: 'APP/CLOSE_OPEN_MODAL',
  SET_LANGUAGE: 'APP/SET_LANGUAGE',
} as const;

const initialState: TAppState = {
  globalModalId: null,
  showGlobalModal: false,
  globalModalPayload: null,
  currentLang: 'en',
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<TOpenGlobalModalPayload>) => {
      state.globalModalId = action.payload.id;
      state.showGlobalModal = true;
      state.globalModalPayload = action.payload.data || null;
    },
    closeModal: (state) => {
      state.globalModalId = null;
      state.showGlobalModal = false;
    },
    setLanguage: (state, action: PayloadAction<{ language: TLangSlug }>) => {
      state.currentLang = action.payload.language;
    },
  },
});

export const { actions, name, reducer } = appSlice;
export default reducer;
